var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('b-alert', {
    staticClass: "p-2",
    attrs: {
      "variant": "warning",
      "fade": "",
      "show": _vm.showWarningInvalidSortingLocation
    }
  }, [_vm._v(" Onjuiste legplaats. Probeer het opnieuw."), _c('br')]), _c('b-alert', {
    staticClass: "p-2",
    attrs: {
      "variant": "danger",
      "fade": "",
      "show": _vm.showError
    }
  }, [_vm._v(" Fout bij het opslaan van de legplaats. Neem contact op met "), _c('a', {
    attrs: {
      "href": "mailto:info@omnistock.nl"
    }
  }, [_vm._v("OmniStock")]), _vm._v(". ")]), _vm.storageLocationIdentifier ? _c('p', {
    attrs: {
      "data-identifier": _vm.storageLocationIdentifier
    }
  }, [_vm._v(" Plaats "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleSingularOrPlural)
    }
  }), _vm._v(" in legplaats "), _c('strong', [_vm._v(_vm._s(_vm.storageLocationDisplayName))])]) : _c('p', [_vm._v(" Plaats "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.articleSingularOrPlural)
    }
  }), _vm._v(" in een "), _c('strong', [_vm._v("lege legplaats")])]), _c('b-input', {
    key: _vm.isProcessing,
    ref: "valueInput",
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "disabled": _vm.isProcessing,
      "inputmode": _vm.inputFocusedManually ? 'text' : 'none',
      "type": "text",
      "placeholder": "Legplaats",
      "required": "",
      "autofocus": "",
      "autocomplete": "off"
    },
    on: {
      "click": function ($event) {
        _vm.inputFocusedManually = true;
      }
    },
    model: {
      value: _vm.scanValue,
      callback: function ($$v) {
        _vm.scanValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "scanValue"
    }
  }), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.isProcessing
    }
  }, [!_vm.isProcessing ? _c('span', [_vm._v("Scan")]) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }